import {call, put} from "redux-saga/effects";
import { SDK } from "../../../sdk";
import {trackError} from "../../log/actions";
import consumeProduct from "./consumeProduct";

export default function* processPendingPurchases() {
    try {
        const pendingPurchases = yield call([SDK.instance, SDK.instance.getPurchases]);
        if (!pendingPurchases || !pendingPurchases.length)
            return;

        for (let purchase of pendingPurchases) {
            yield call(consumeProduct, purchase);
        }
    }
    catch (error) {
        yield put(trackError({
            category: "paymentsSaga",
            message: "Failed to process pending purchases",
            error: error,
        }));
    }
}